<script>
    import Layout from "../../layouts/main"
    import PageHeader from "../../components/page-header"
    import ItemTable from "./components/ItemTable.vue"
    import FormModal from "../../components/modals/FormModal.vue"

    export default {
        components: { Layout, PageHeader, ItemTable, FormModal },
        props: {
            checklistItems: {
                type: Array,
                default: function() {
                    return []
                }
            },
            defaultChecklistDeletedItems: {
                type: Array,
                default: function() {
                    return []
                }
            }
        },
        data() {
            return {
                title: "Onboarding Checklist Management",
                items: [
                    {
                        text: "Apps",
                        href: "/",
                    },
                    {
                        text: "Onboarding Checklist",
                        active: true,
                    },
                ],
                showInfoModal: false
            };
        },
        computed: {
            // Example Admin, Enterprise Partner, Tax Company, Tax Payer
            browserTitle() {
                return this.$page.props.auth.user.user_type_text + ' - Onboarding Checklist Management';
            }
        },
        methods: {
            informationModalManage() {
                this.showInfoModal = true
            }
        }
    }
</script>
    
<template>
    <Layout>
        <Head :title="browserTitle" />
        <PageHeader 
            :title="title" 
            :items="items" 
            :showInfo="true" 
            @showModal="informationModalManage"
        />
        <div class="d-xl-flex">
            <div class="w-100">
                <div class="d-md-flex">
                    <div class="w-100">
                        <ItemTable
                            :checklistItems="checklistItems"
                            :defaultChecklistDeletedItems="defaultChecklistDeletedItems"
                        />
                    </div>
                </div>
            </div>
        </div>
        <FormModal
            :isShow="showInfoModal"
            title="Some instructions about this page!"
            :isShowSubmitButton="false"
            :isShowCancelButton="true"
            closeButtonText="Close"
            @hideModal="showInfoModal = false"
        >
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 p-2">
                    <ul>
                        <li>Onboarding checklists can be used to track the onboarding process for Tax Companies and are displayed in every Tax Company's profile.</li>
                        <li>You can edit this default list and have those changes reflect to all current and future Tax Companies, or just future Tax Companies.</li>
                    </ul>
                </div>
            </div>
        </FormModal>
    </Layout>
</template>
    